import React, {FC} from 'react';
import styled from 'styled-components';

import {DraftMessageModel} from '../../../../libs/shared/core/src/models/api/messageModel';
import {RecipientRolesEnum} from '../../../../libs/shared/core/src/models/api/recipientModel';
import {TeammateModel} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {ComposerPanelId, ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {composerDetailsTokenBoxStyle} from '../../../../libs/shared/ui/src/styles/composerStyles';
import {ConversationModel} from '../../../models/api/conversationModel';
import {RecipientRoleFormatter} from '../../common/formatters/recipientRoleFormatter';
import {ComposerHeaderBanner} from './banner/composerHeaderBanner';
import {ComposerChannelPickerContainer} from './channelPicker/composerChannelPickerContainer';
import {ChannelSaver} from './channelPicker/pickChannelDropdownContainer';

/*
 * Props.
 */

export interface TweetComposerHeaderProps {
  message: DraftMessageModel;
  conversation: ConversationModel | null;
  user: TeammateModel;
  saveChannel: ChannelSaver;
  panelId: ComposerPanelId | ViewerPanelId;
}

/*
 * Style.
 */

const StyledHeaderDiv = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    'banner'
    'from';
  border-bottom: 1px solid ${(p) => p.theme.message.border};
`;

const StyledBannerDiv = styled.div`
  grid-area: banner;
  padding-bottom: 10px;
`;

const StyledRecipientDiv = styled.div`
  grid-area: from;
  display: flex;
  padding: 0px 0px 10px 16px;
`;

const StyledTitleDiv = styled.div`
  flex-shrink: 0;
  ${composerDetailsTokenBoxStyle};
  color: ${(p) => p.theme.greys.shade70};
  margin-right: 6px;
`;

/*
 * Component.
 */

export const TweetComposerHeader: FC<TweetComposerHeaderProps> = (props) => (
  <StyledHeaderDiv>
    <StyledBannerDiv>{maybeRenderComposerHeaderBanner(props)}</StyledBannerDiv>

    <StyledRecipientDiv>
      <StyledTitleDiv>
        <RecipientRoleFormatter role={RecipientRolesEnum.FROM} />:
      </StyledTitleDiv>
      <ComposerChannelPickerContainer {...props} />
    </StyledRecipientDiv>
  </StyledHeaderDiv>
);

/*
 * Helpers.
 */

function maybeRenderComposerHeaderBanner(props: TweetComposerHeaderProps) {
  const {message, conversation, user, panelId} = props;
  if (!conversation) {
    return null;
  }

  return (
    <ComposerHeaderBanner
      message={message}
      conversation={conversation}
      teammateId={user.id}
      panelId={panelId}
    />
  );
}
